import { render, staticRenderFns } from "./QButton.vue?vue&type=template&id=5cc7a7eb&scoped=true&"
import script from "./QButton.vue?vue&type=script&lang=ts&"
export * from "./QButton.vue?vue&type=script&lang=ts&"
import style0 from "./QButton.vue?vue&type=style&index=0&id=5cc7a7eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7a7eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
